const createFormWithFields = (fields: {[name: string]: string}) => {
    const form = Object.entries(fields).reduce((formElement, [name, value]) => {
        const formField = document.createElement('input')

        formField.type = 'hidden'
        formField.name = name
        formField.value = value

        formElement.appendChild(formField)
        return formElement
    }, document.createElement('form'))

    return form
}

export const submitForm = ({url, fields}: {url: string; fields: {[name: string]: string}}) => {
    const form = createFormWithFields(fields ?? {})
    const formId = Math.random().toString(36).slice(2)

    form.id = formId
    form.name = formId
    form.action = url
    form.method = 'POST'
    form.target = '_self'

    document.body.appendChild(form)

    form.requestSubmit ? form.requestSubmit() : form.submit()
}

export const submitFormToTarget = ({
    method,
    url,
    fields = {},
    target,
    onSuccess,
    onFail,
}: {
    method: 'GET' | 'POST'
    url: string
    fields?: {[name: string]: string}
    target: string
    onSuccess: () => void
    onFail: () => void
}) => {
    const form = createFormWithFields(fields)
    const targets = document.getElementsByName(target)
    const iframeTarget = Array.prototype.find.call(targets, (tag) => tag.tagName === 'IFRAME')

    if (!iframeTarget) {
        throw new Error('no target iframe exits')
    }

    form.target = target
    form.method = method ?? 'POST'
    form.action = url

    document.body.appendChild(form)

    iframeTarget.addEventListener('load', onSuccess)
    iframeTarget.addEventListener('error', onFail)

    form.requestSubmit ? form.requestSubmit() : form.submit()
}
